import React from 'react';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular';
  width?: string | number;
  height?: string | number;
  repeat?: number;
}

export default function SkeletonLoader({ 
  className = '', 
  variant = 'rectangular',
  width,
  height,
  repeat = 1
}: SkeletonProps) {
  const baseClasses = "animate-pulse bg-gray-200";
  const variantClasses = {
    text: "h-4 rounded",
    circular: "rounded-full",
    rectangular: "rounded-lg"
  };

  const style = {
    width: width,
    height: height
  };

  const Skeleton = () => (
    <div 
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      style={style}
    />
  );

  if (repeat === 1) return <Skeleton />;

  return (
    <div className="space-y-4">
      {Array.from({ length: repeat }).map((_, index) => (
        <Skeleton key={index} />
      ))}
    </div>
  );
}